import axiosInstance from 'utils/axiosInstance';

export const GlobalSearchService = async (values: {
  value: string;
  regex: boolean;
}): Promise<SelectOptionResponse[]> => {
  const { data } = await axiosInstance.post('/api/home/GlobalSearch', values);
  return data;
};
